// src/constants/statusColors.js
export const statusColors = {
  Open: "#28a745",
  "Working on It": "#17a2b8",
  "In Staging": "#ffc107",
  "In Test": "#fd7e14",
  "In Production": "#6610f2",
  "In review": "#6c757d",
  Closed: "#dc3545",
};
